import bannerImg from "../../../../Assets/Images/Web Tools - SVG - Edited 1.png";
import { motion } from "framer-motion";
import "../AllBanner/technologiesBanner.css";
import { Link } from "react-router-dom";

const WebBanner = () => {
  return (
    <div
      className="tech-web-banner"
      style={{ backgroundColor: " #0b4f5d", color: "white" }}
    >
      <div
        className="  d-flex flex-column flex-md-row align-items-center justify-content-center  py-5"
        style={{
          padding: "1rem 0",
          gap: "80px",
          width: "90%",
          margin: "0 Auto",
        }}
      >
        {/* Left Text Section */}
        <div
          className="d-flex flex-column justify-content-center text-center text-md-start align-items-center align-items-md-start"
          style={{
            flex: "1",
            maxWidth: "636px",
          }}
        >
          <h4 className="sub-heading  " style={{ color: "#F7A630" }}>
            {" "}
            Website Technologies and Frameworks
          </h4>
          <h2 className="database-heading web-tech-heading fw-semibold text-center text-md-start mb-3">
            Web Technologies That Stay Reliable Over Time
          </h2>
          <p className="small text-center text-md-start  database-text mb-4">
            Web technology choices tend to reveal their impact later, not at
            launch. When the traffic starts to grow, integrations begin to stack
            up, and teams are constantly changing, weak foundations begin to
            slow everything down. At Quad Theory Ltd, we work with web
            technologies that are proven under real usage, easy to maintain and
            flexible enough to evolve.
          </p>

          <Link to="/contact-us">
            <motion.button
              type="button"
              className=" px-5 py-3  mx-1 rounded-pill align-self-start mx-auto mx-md-0"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                //  scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                fontSize: "1.4rem",
              }}
            >
              Talk To Our Web Experts
            </motion.button>
          </Link>
        </div>

        {/* Right Image Section */}
        <div style={{ flex: "1", position: "relative", textAlign: "center" }}>
          <img
            src={bannerImg}
            alt="Banner"
            className="img-fluid tech_web_banner_img"
            style={{
              mixBlendMode: "brighten",
              opacity: 2.0,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WebBanner;
